import { AppProviders, LibraryProviders } from "web/Providers"
import { BrowserRouter as Router } from "react-router-dom"
import { Controller } from "@hotwired/stimulus"
import {
  ErrorBoundary,
  Loading,
  ModalContainer,
  ViewOrEditDealAsset,
} from "web/components"
import { render } from "react-dom"
import { TLOContextProvider } from "web/contexts"
import { useDealAsset } from "web/hooks/data"
import React, { Suspense } from "react"

export default class DealAssetViewOrEditTLOController extends Controller {
  static values = {
    dealAssetId: Number,
    excludedFieldIds: Array,
    supportsMissingStageFields: Boolean,
  }

  initialize() {
    global.React = React
  }

  connect() {
    const DealAssetTLOContextProvider = ({ children }) => {
      return (
        <TLOContextProvider
          subjectType="deal_asset"
          data={useDealAsset(this.dealAssetIdValue)}
        >
          {children}
        </TLOContextProvider>
      )
    }

    render(
      <Suspense fallback={<Loading inline />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <DealAssetTLOContextProvider>
                <ErrorBoundary>
                  <ViewOrEditDealAsset
                    excludedFieldIds={this.excludedFieldIdsValue}
                    supportsMissingStageFields={
                      this.supportsMissingStageFieldsValue
                    }
                  />
                </ErrorBoundary>
              </DealAssetTLOContextProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }
}
